module.exports = __webpack_public_path__ + "static/media/HBI.d8be34a3.jpg";